import ArticleCard from "@/components/base/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";
import { articles } from "@/mocks/articles";

export default function LatestArticles() {
  const featured = articles[0];
  const grid = articles.slice(1, 3);
  const hotList = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 5);

  return (
    <section id="latest" className="mx-auto max-w-content scroll-mt-24 px-4 py-16 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="LATEST REVIEW"
        title="最新复盘档案"
        description="刚归档的几篇复盘，附完整时间线。先从最近发生的开始看，再回头补旧账。"
        action={{ to: "/archive", label: "查看全部 214 篇" }}
      />

      <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <ArticleCard article={featured} variant="feature" />
          <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2">
            {grid.map((item) => (
              <ArticleCard key={item.id} article={item} />
            ))}
          </div>
        </div>

        <aside className="lg:col-span-4">
          <div className="rounded-lg border border-background-200/70 bg-background-100 p-5 md:p-6">
            <div className="flex items-center justify-between border-b border-background-200/70 pb-4">
              <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
                <i className="ri-fire-line text-lg text-primary-400" />
                本周热读
              </h3>
              <span className="text-[11px] text-foreground-500">按阅读量排序</span>
            </div>
            <div className="mt-1">
              {hotList.map((item, index) => (
                <ArticleCard key={item.id} article={item} variant="compact" index={index} />
              ))}
            </div>
          </div>

          <div className="mt-6 rounded-lg border border-accent-900/50 bg-gradient-to-b from-primary-950 to-background-100 p-5 md:p-6">
            <p className="flex items-center gap-2 text-xs tracking-[0.22em] text-accent-400">
              <i className="ri-edit-line text-base" />
              编辑手记
            </p>
            <p className="mt-3 font-heading text-base leading-relaxed text-foreground-800">
              「时间线排对了，大多数争议其实会自己消失。」
            </p>
            <p className="mt-3 text-xs leading-relaxed text-foreground-500">
              我们坚持先摆事实顺序，再谈观点。无法核实的节点会明确标注存疑，而不是含糊带过。
            </p>
          </div>
        </aside>
      </div>
    </section>
  );
}